<script setup>
import {Head, Link, useForm} from "@inertiajs/vue3";

import PageLayout from "@/Layouts/PageLayout.vue";
import GeneralLayout from "@/Layouts/GeneralLayout.vue";
import {frequently_asked_questions} from "@/constants.js";
import ErrorDisplay from "@/Components/ErrorDisplay.vue";

const props = defineProps({
    errors: Object,
});
const form = useForm({
    name: '',
    email: '',
    subject: '',
    body: '',
});

const submit = () => {
    form.post(route('page.post_contact_us'), {
        onSuccess: () => {
            form.reset();
        },
    });
};
</script>

<template>
    <Head title="Contact Us"/>
    <GeneralLayout>
        <template #header>
            <h2 class=" py-6 text-4xl font-extrabold text-gray-900 dark:text-white">
                Contact Us</h2>
        </template>
        <section class="max-w-6xl mx-auto bg-white dark:bg-gray-900">
            <div class="py-4 lg:py-8 px-4 mx-auto max-w-screen-md">
                <p class="text-lg leading-7 text-gray-500 dark:text-gray-400">
                Have questions or feedback? We're here to help! Contact our team for assistance with technical issues, suggestions, or information about our premium plans.
            </p>
                <ErrorDisplay :validation-errors="errors"/>
                <form @submit.prevent="submit" method="post" class="space-y-8">
                    <div>
                        <label for="email" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Your
                            email</label>
                        <input v-model="form.name" type="text" id="name"
                               class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
                               placeholder="Your Name" required>
                    </div>
                    <div>
                        <label for="email" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Your
                            email</label>
                        <input v-model="form.email" type="email" id="email"
                               class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
                               placeholder="eg. name@gmail.com" required>
                    </div>
                    <div>
                        <label for="subject" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Subject</label>
                        <input v-model="form.subject" type="text" id="subject"
                               class="block p-3 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 shadow-sm focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
                               placeholder="Let us know how we can help you" required>
                    </div>
                    <div class="sm:col-span-2">
                        <label for="body" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400">Your
                            message</label>
                        <textarea v-model="form.body" id="body" rows="6"
                                  class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg shadow-sm border border-gray-300 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                                  placeholder="Your message in detail..."></textarea>
                    </div>
                    <button type="submit"
                            class="py-3 px-5 text-sm font-medium text-center text-white rounded-lg bg-primary-700 sm:w-fit hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">
                        Send message
                    </button>
                </form>
            </div>
        </section>

    </GeneralLayout>
</template>

<style scoped>

</style>
